import { useMutation, useQueryClient } from '@tanstack/react-query';
import i18next from 'i18next';
import { toast } from 'react-toastify';
import type { Message } from '../models/message';
import { messageKeys } from '../queries/messsage-keys';
import { sendMessageApi } from '../services/message.service';

interface ForwardMessageParams {
  messageId: string;
  conversationId: string;
  message: Message;
}

export const useMessageForward = () => {
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: async ({ messageId, conversationId, message }: ForwardMessageParams) => {
      return await sendMessageApi(conversationId, {
        contentType: message.contentType,
        originalMessageId: messageId,
        content: message.content,
        attachments: message.structuredAttachments || []
      });
    },
    onSuccess: (_, { conversationId }) => {
      // Invalidate the conversation's messages to show the new forwarded message
      queryClient.invalidateQueries({
        queryKey: messageKeys.conversation(conversationId)
      });
    },
    onError: (error) => {
      console.error('Failed to forward message:', error);
      toast.error(i18next.t('messages.forward.error'));
    }
  });

  return { mutateAsync };
};
